
import { Suspense } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
} from "react-router-dom";
import "./App.css";
import NotFound from "./pages/NotFound";
import MarketingRoutes from "./routes/MarketingRoutes";
import { useAnalytics } from "./hooks/useAnalytics";

function AnalyticsWrapper({ children }: { children: React.ReactNode }) {
  useAnalytics();
  return <>{children}</>;
}

function App() {
  return (
    <Router>
      <AnalyticsWrapper>
        <div className="min-h-screen bg-background">
        <Suspense fallback={<div className="min-h-screen flex items-center justify-center"><div className="animate-pulse text-saas-blue">Loading...</div></div>}>
          <Routes>
            {/* Marketing routes only */}
            {MarketingRoutes()}
            
            {/* Catch-all route for 404 errors */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
        </div>
      </AnalyticsWrapper>
    </Router>
  );
}

export default App;
